import colors from 'globals/colors'
import styled from 'styled-components'
import measures from 'globals/measures'

export const ExportsActionsWrapper = styled.div`
  margin-top: 38px;
  display: flex;
  align-items: center;
  
  @media (max-width: ${measures.mobileThreshold}px) {
    margin-top: 18px;
    flex-wrap: wrap;
  }
`

export const SelectedRange = styled.div`
  color: ${colors.steelGrey};
  margin-left: 20px;
  
  & > span {
    color: ${colors.darkGrey};
  }
`

interface ExportButtonProps {
  noMargin: boolean
}

export const ExportButton = styled.div<ExportButtonProps>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: ${measures.mobileThreshold}px) {
    flex-basis: 100%;
    
    & > button {
      width: 100%;
      margin-top: ${(props) => props.noMargin ? '0' : '28px'};
    }
  }
`
